import(/* webpackMode: "eager" */ "/app/app/admin-2025/page.tsx");
